import React, { useEffect, useState, useContext, useCallback } from "react";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import GenericCard from "components/ui/cards/GenericCard";

import ReceiptItem from "features/accounting/receipts/ReceiptItem";

import Card from "shared/components/UIElements/Card";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";

import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";

import { getContractYearLabel } from "shared/util/relationaldata";

const ContractReceipts = ({ contract }) => {
  const { receipts, InsertReceipt } = useContext(StoreContext);

  const [loadedItem, setLoadedItem] = useState();

  const [currentReceipts, setCurrentReceipts] = useState();

  const [totalStudyPayed, setTotalStudyPayed] = useState();
  const [totalNormalPayed, setTotalNormalPayed] = useState();
  // eslint-disable-next-line no-unused-vars
  const [calculatedInvoices, setCalculatedInvoices] = useState();
  // eslint-disable-next-line no-unused-vars
  const [totalPayed, setTotalPayed] = useState();

  const ItemTypeTR = "Fatura";

  const { isLoading, error, sendRequest } = useHttpClient();

  const fetchItem = useCallback(async () => {
    try {
      setLoadedItem(contract);
      const allreceipts = receipts.filter((item) => item.contract.id.toString() === contract.id);
      setCurrentReceipts(allreceipts);

      let totalPayed = 0;
      let totalStudyPayed = 0;
      let totalNormalPayed = 0;

      allreceipts.forEach((item) => {
        totalPayed += item.amount;
        if (item.isStudyPayment) {
          totalStudyPayed += item.amount;
        } else {
          totalNormalPayed += item.amount;
        }
      });
      setTotalPayed(totalPayed);
      setTotalStudyPayed(totalStudyPayed);
      setTotalNormalPayed(totalNormalPayed);

      const totalAmount = contract.finalAmount;
      const toBeInvoiced = totalAmount;

      if (getContractYearLabel(contract.year) !== "2025-2026" || getContractYearLabel(contract.year) !== "2026-2027") {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/faturas/${contract.id}`);
        const faturas = response.fatura;

        const months = ["Eylül", "Ekim", "Kasım", "Aralık", "Ocak", "Şubat", "Mart", "Nisan", "Mayıs"];
        let monthAmounts = [];

        for (let index = 0; index < months.length; index++) {
          if (months[index] === "Eylül") {
            monthAmounts.push(faturas.september);
          }
          if (months[index] === "Ekim") {
            monthAmounts.push(faturas.october);
          }
          if (months[index] === "Kasım") {
            monthAmounts.push(faturas.november);
          }
          if (months[index] === "Aralık") {
            monthAmounts.push(faturas.december);
          }
          if (months[index] === "Ocak") {
            monthAmounts.push(faturas.january);
          }
          if (months[index] === "Şubat") {
            monthAmounts.push(faturas.february);
          }
          if (months[index] === "Mart") {
            monthAmounts.push(faturas.march);
          }
          if (months[index] === "Nisan") {
            monthAmounts.push(faturas.april);
          }
          if (months[index] === "Mayıs") {
            monthAmounts.push(faturas.may);
          }
        }

        if (toBeInvoiced > 0) {
          let calculatedInvoices = [];
          for (let index = 0; index < months.length; index++) {
            const invoice = {
              month: months[index],
              // amount: faturas.find(fatura => fatura.)(toBeInvoiced / months.length).toFixed(1),
              amount: monthAmounts[index].toFixed(1),
              id: months[index],
            };
            calculatedInvoices.push(invoice);
          }
          setCalculatedInvoices(calculatedInvoices);
        }
      } else {
      }
    } catch (err) {}
  }, [contract, receipts, sendRequest]);

  useEffect(() => {
    fetchItem();

    //setCalculatedInvoices();
  }, [contract, fetchItem]);

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!loadedItem && !error) {
    return (
      <div className="center">
        <Card>
          <h2>{ItemTypeTR} bulunamadı.</h2>
        </Card>
      </div>
    );
  }

  return (
    <React.Fragment>
      {!isLoading && loadedItem && (
        <React.Fragment>
          <div className="form-container">
            <div className="horizontal-flex" style={{ justifyContent: "space-between" }}>
              <GenericCard
                dismissible={false}
                onDismiss={() => console.log("Kart kapatıldı")}
                style={{ paddingBottom: "0px" }}
              >
                <div style={{ flex: 1 }}>
                  <h4>Yeni Tahsilat</h4>
                  <div style={{ width: "600px", minHeight: "300px" }}>
                    <ReceiptItem fixedContract={contract} isNewItem={true} InsertItem={InsertReceipt} />
                  </div>
                </div>
              </GenericCard>

              <div>
                <GenericCard
                  dismissible={false}
                  onDismiss={() => console.log("Kart kapatıldı")}
                  style={{ paddingBottom: "20px", width: "450px" }}
                >
                  <h4>Tahsilatlar</h4>

                  {/* Etüd Ödemeleri */}
                  {currentReceipts.filter((receipt) => receipt.isStudyPayment).length > 0 && (
                    <div style={{ marginBottom: "20px" }}>
                      <h4 style={{ marginBottom: "10px" }}>Etüd Ödemeleri (Toplam: {totalStudyPayed})</h4>

                      <TableContainer component={Paper} sx={{ width: 400 }}>
                        <Table sx={{ justifyContent: "flex-start" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Tarih</TableCell>
                              <TableCell>Etüd Ödemesi</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {currentReceipts
                              .filter((receipt) => receipt.isStudyPayment)
                              .map((row) => (
                                <TableRow key={row.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                  <TableCell component="th" scope="row">
                                    {row.date}
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>{row.amount}</TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  )}

                  {/* Normal Tahsilatlar */}
                  {currentReceipts.filter((receipt) => !receipt.isStudyPayment).length > 0 && (
                    <div style={{ marginBottom: "10px" }}>
                      <h4 style={{ marginBottom: "10px" }}>Normal Tahsilatlar (Toplam = {totalNormalPayed})</h4>

                      <TableContainer component={Paper} sx={{ width: 400 }}>
                        <Table sx={{ justifyContent: "flex-start" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Tarih</TableCell>
                              <TableCell>Ödenen</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {currentReceipts
                              .filter((receipt) => !receipt.isStudyPayment)
                              .map((row) => (
                                <TableRow key={row.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                  <TableCell component="th" scope="row">
                                    {row.date}
                                  </TableCell>
                                  <TableCell>{row.amount}</TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  )}
                </GenericCard>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ContractReceipts;
